<template>
  <div
    v-if="shouldShowLayout"
    class="relative flex gap-x-4 px-4 py-3 min-h-screen overflow-hidden bg-gray-50"
  >
    <!-- Desktop Sidebar -->
    <div class="hidden md:block">
      <TheSidebar :open="sidebarOpen" @close-sidebar="toggleSidebar" />
    </div>

    <!-- Mobile Sidebar Overlay -->
    <transition
      enter-active-class="transition-opacity duration-300 ease-out"
      leave-active-class="transition-opacity duration-300 ease-out"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div v-if="sidebarOpen" class="fixed inset-0 z-50 md:hidden">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black bg-opacity-50"
          @click="toggleSidebar"
        ></div>
        <!-- Sidebar -->
        <transition
          enter-active-class="transition-transform duration-300 ease-out"
          leave-active-class="transition-transform duration-300 ease-out"
          enter-from-class="transform -translate-x-full"
          leave-to-class="transform -translate-x-full"
        >
          <div
            v-if="sidebarOpen"
            class="absolute left-0 top-0 bottom-0 w-80 max-w-sm"
          >
            <div class="h-full p-4">
              <TheSidebar :open="true" @close-sidebar="toggleSidebar" />
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <div
      class="flex-1 flex flex-col transition-all duration-300 ease-out"
      :class="{ 'md:ml-0': !sidebarOpen }"
    >
      <NavigationBar :open="sidebarOpen" @toggle-sidebar="toggleSidebar" />
      <div class="flex-1 overflow-hidden">
        <router-view />
      </div>
    </div>
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "./components/NavigationBar.vue";
import TheSidebar from "@/components/dashboard/TheSidebar.vue";
import { isAuthenticated } from "./services/token";

export default {
  name: "App",
  components: {
    NavigationBar,
    TheSidebar,
  },
  data() {
    return {
      isAuthenticated: false,
      sidebarOpen: window.innerWidth >= 768, // Open by default on desktop, closed on mobile
    };
  },
  created() {
    this.checkAuthentication();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    checkAuthentication() {
      this.isAuthenticated = isAuthenticated();
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    handleResize() {
      // Auto-close sidebar on mobile, auto-open on desktop
      if (window.innerWidth < 768) {
        this.sidebarOpen = false;
      } else {
        this.sidebarOpen = true;
      }
    },
  },
  computed: {
    shouldShowLayout() {
      const hiddenRoutes = ["/login", "/register", "/"];

      return !hiddenRoutes.includes(this.$route.path);
    },
  },
};
</script>

<style></style>
